<template>
  <div class="circle-background" :style="{
    height: (radius - 10) * 2 + 'px',
    width: (radius - 10) * 2 + 'px',
    'border-radius': radius + 'px',
    'border-width': stroke + 'px'
  }">
    <svg
      :height="radius * 2"
      :width="radius * 2" >
      <circle
        class="circle"
        :stroke="strokeColor"
        :stroke-dasharray="circumference + ' ' + circumference"
        :style="{ strokeDashoffset: strokeDashoffset }"
        :stroke-width="stroke"
        fill="transparent"
        :r="normalizedRadius"
        :cx="radius"
        :cy="radius"
        stroke-linecap="round"
      />
    </svg>
    <div>Your score is<br><span class="score">{{score}}/{{questionCount}}</span>
    </div>
    
  </div>
</template>

<script>
  export default {
    name: 'ResultCircle',
    props: {
      progress: Number,
      score: Number,
      questionCount: Number,
      strokeColor: String,
    },
    data() {
      const radius = 100
      const stroke = 20
      const normalizedRadius = radius - stroke;
      const circumference = normalizedRadius * 2 * Math.PI;
      
      return {
        radius,
        normalizedRadius,
        circumference,
        stroke
      };
    },
    computed: {
      strokeDashoffset() {
        return this.circumference - this.progress / 100 * this.circumference;
      }
    },
  }

</script>

<style lang="scss" scoped>
@import "@/styles";
.circle-background {
  position: relative;
  box-shadow: 0px 3px 7px 1px rgba(0,0,0,0.2);
  box-sizing: border-box;
  border-style: solid;
  border-color: $primary;
  svg {
    position: absolute;
    top: -30px;
    left: -30px;
  }
  div {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: $primary;
    font-size: 16px;
    font-weight: 600;
    .score {
      font-size: 24px;
    }
  }
}

.circle {
  transition: stroke-dashoffset 0.35s;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
  border-radius: 20px;
}
</style>